import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { setSearchParams } from '@/store/search/actions';
import { getTagName } from '@/store/tags/actions';

import Search from './Search';

import getQueryString from '@shared/utils/get-query-string';

class ContextSearch extends PureComponent {
  constructor(props) {
    super(props);
    const { itemId, itemTag, type } = props?.queryParams || props?.initialQuerySearchParams || {};

    // Санитизируем начальное значение поиска
    const initialValue = props?.queryParams ? props?.queryParams[type] : '';
    const sanitizedInitialValue = this.sanitizeSearchTextStatic(initialValue);

    this.state = {
      location: document.location.search,
      type: (type && props.searchTypes.find(item => item.type === type)) || props.searchTypes[0],
      value: sanitizedInitialValue,
      itemTag: itemTag || '',
      itemId: itemId || undefined,
      showClearButton: false,
      hasSearched: false,
    };
  }

  // Статический метод для санитизации в конструкторе (до создания экземпляра)
  sanitizeSearchTextStatic = text => {
    if (!text || typeof text !== 'string') return text;

    // Удаляем HTML теги и символы с помощью регулярных выражений
    return text
      .replace(/<[^>]*>/g, '') // Удаляем HTML теги
      .replace(/[<>&"']/g, '') // Удаляем опасные HTML символы
      .trim();
  };

  // Функция для санитизации текста - удаляет HTML теги
  sanitizeSearchText = text => {
    if (!text || typeof text !== 'string') return text;

    // Удаляем HTML теги и символы с помощью регулярных выражений
    return text
      .replace(/<[^>]*>/g, '') // Удаляем HTML теги
      .replace(/[<>&"']/g, '') // Удаляем опасные HTML символы
      .trim();
  };

  getCurrentSearchType = () => this.props.searchTypes.find(el => el.type === this.state?.type?.type).searchType;

  updateTagName = tagId => {
    this.props.getTagName(tagId, ({ name }) => {
      const sanitizedName = this.sanitizeSearchText(name);
      this.onChange(sanitizedName);
    });
  };

  updateSearchQuery = () => {
    const { value, itemId, itemTag, type, location } = this.state;

    const params = new URLSearchParams(location);

    this.props.navigate({
      search: getQueryString({
        [type ? type.type : 'search']: value,
        [itemTag]: itemTag === 'publisher' ? value : itemId,
        type: type && type.type,
        skillids: params.get('skillids'),
      }),
      replace: true,
    });
  };

  onChange = value => {
    const sanitizedValue = this.sanitizeSearchText(value);
    this.setState({ value: sanitizedValue }, () => {
      this.props.onChange(sanitizedValue, this.getCurrentSearchType());
    });
  };

  onTypeChange = type => {
    const findSearchType = this.props.searchTypes.find(el => el.type === type);
    if (!findSearchType) return;
    this.setState(
      {
        type: { ...findSearchType },
      },
      () => {
        if (this.state.value) this.props.onChange(this.state.value, this.getCurrentSearchType());
      }
    );
  };

  onSearchSuggestClick = (suggestItem, suggestType) => {
    const { searchTypes } = this.props;
    const itemType =
      searchTypes.find(item => item.name.toLowerCase() === suggestItem.type.toLowerCase()) || suggestType;

    const itemTag = itemType?.tagType || itemType?.type || '';
    const sanitizedName = this.sanitizeSearchText(suggestItem.name);

    this.setState(
      {
        itemTag,
        itemId: suggestItem.id,
        value: sanitizedName,
      },
      this.updateSearchQuery
    );

    this.props.onSearchSuggestClick(suggestItem.id, sanitizedName, itemTag);
  };

  onSubmit = value => {
    const { type } = this.state;
    const sanitizedValue = this.sanitizeSearchText(value);

    if (!sanitizedValue && !this.state.hasSearched) {
      return;
    }

    this.props.onSearchSubmit({
      type: type?.type,
      value: sanitizedValue,
    });

    if (!sanitizedValue) {
      this.setState(
        {
          value: '',
          type: this.props.searchTypes[0],
          itemId: undefined,
          itemTag: '',
          hasSearched: false,
        },
        this.updateSearchQuery
      );
    } else {
      // Обновляем состояние с очищенным значением
      this.setState({ value: sanitizedValue, hasSearched: true }, this.updateSearchQuery);
    }
  };

  isDirty = () => {
    return this.props.isFiltered;
  };

  componentDidMount() {
    if (this.state.itemTag === 'TAG' && this.state.itemId && !this.state.value) {
      this.updateTagName(this.state.itemId);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.searchTypes?.[0].name !== this.props?.searchTypes?.[0].name) {
      this.setState({ type: this.props.searchTypes[0] });
    }

    if (document.location.search) {
      this.setState({ location: document.location.search });
    }

    if (
      prevProps.queryParams !== this.props.queryParams ||
      (document.location.search !== this.state.location && !document.location.search)
    ) {
      const { queryParams } = this.props;
      const type = queryParams?.type || this.state.type?.type;
      const newValue = this.sanitizeSearchText(queryParams?.[type] || '');

      const typeObject = this.props.searchTypes.find(el => el.type === type);

      this.setState({ value: newValue, location: document.location.search, type: typeObject });
    }
  }

  render() {
    const { searchResults, searchTypes, dataQa, isNews } = this.props;

    const { type, value, itemId, hasSearched } = this.state;

    const data =
      itemId && searchResults
        ? searchResults.filter(values => values?.name?.toLocaleLowerCase().includes(value?.toLocaleLowerCase()))
        : searchResults;

    return (
      <Search
        dataQa={dataQa}
        results={data}
        onChange={this.onChange}
        onSearchSuggestClick={this.onSearchSuggestClick}
        onSearchTypeChange={this.onTypeChange}
        onSubmit={this.onSubmit}
        types={searchTypes}
        searchText={value}
        searchType={type}
        showClearButton={this.isDirty()}
        isFavorite={this.props.isFavorite}
        isNews={isNews}
        hasSearched={hasSearched}
      />
    );
  }
}

const mapActionsToProps = {
  getTagName,
  setSearchParams,
};

export default connect(null, mapActionsToProps)(ContextSearch);
